import { hamburgerIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Menu = createIcon({
  displayName: 'Menu',
  paths: [
    'M128 256h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM469.333 554.667h-341.333c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h341.333c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667zM640 853.333h-512c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h512c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667z'
  ],
  canvasPaths: canvasIconPaths(hamburgerIcon)
})
